import React from 'react';

import TextField from '@mui/material/TextField';

export default function MultiLIneInput({
  value,
  label,
  onChange = () => {},
  onKeyDown = () => {},
  placeholder,
  helperText,
  ...rest
}) {
  return (
    <TextField
      label={label}
      fullWidth
      size='small'
      multiline
      rows={6}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      helperText={helperText}
      sx={{ mt: 1, mb: 0 }}
      {...rest}
    />
  );
}
